<!--Options-->
<div class="Grid2Col">
	<label for="RemoveRoles">Remove District Roles:</label>
	<div class="InfoGrid">
		<input type="checkbox" class="CHK" id="RemoveRoles" [(ngModel)]="RemoveRoles" />
		<p class="WarningText">NOTE: this includes Level 0 SysAdmin access</p>
	</div>

	<label for="RemoveGroups">Remove District Groups:</label>
	<input type="checkbox" class="CHK" id="RemoveGroups" [(ngModel)]="RemoveGroups" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
